module.exports = __webpack_public_path__ + "static/media/40.ce623cb9.png";